import { styled } from '@mui/material'
import React from 'react'
import { Link, Outlet, useParams } from 'react-router-dom'

//components
import MenuItem from './MenuItem'

//assets
import Logo from '../assets/logo.png'
import { SIDE_PANEL_WIDTH } from '../utils/constants'

import CloudSyncIcon from '@mui/icons-material/CloudSync'
import FilterIcon from '@mui/icons-material/FilterAlt'
import HomeIcon from '@mui/icons-material/Home'
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty'
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts'
import BuildIcon from '@mui/icons-material/Build'
import LoadingSpinner from '../components/LoadingSpinner'
import AdminGlobalStateContext from '../context/AdminGlobalStateContext'

const App = styled('main')(() => ({
  width: '100%',
  height: '100vh',
  display: 'flex',
  color: '#424242',
  backgroundColor: '#fff'
}))

const SidePanel = styled('div')(() => ({
  width: `${SIDE_PANEL_WIDTH}px`,
  height: '100vh',
  borderRight: '1px solid #dedede',
  backgroundColor: '#113969'
}))

const SidePanelInner = styled('div')(() => ({
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  padding: '16px'
}))

const MainContent = styled('div')(() => ({
  width: '100%',
  height: '100vh',
  overflowY: 'auto'
}))

const LogoWrapper = styled('img')(() => ({
  maxWidth: '100%',
  borderRadius: '8px'
}))

const LogoBox = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  padding: '0 16px',
  marginTop: 'auto',
  borderRadius: '8px'
}))

const NavBox = styled('div')(() => ({
  width: '100%',
  display: 'flex',
  gap: '8px',
  flexDirection: 'column',
  marginTop: '12px'
}))

const AdminLayout = () => {
  const { unit } = useParams()

  const [machinesList, setMachinesList] = React.useState([])
  const [fetchingMachineState, setFetchingMachineState] = React.useState('idle')

  const MENU_ICON_FONT = 'small'

  const SidebarData = [
    {
      title: 'Home',
      path: `/${unit}`,
      renderIcon: () => <HomeIcon fontSize={MENU_ICON_FONT} />
    },
    {
      title: 'Manage data',
      path: `/${unit}/admin`,
      renderIcon: () => <ManageAccountsIcon fontSize={MENU_ICON_FONT} />
    },
    {
      title: 'Shift config',
      path: `/${unit}/admin/shift-config`,
      renderIcon: () => <HourglassEmptyIcon fontSize={MENU_ICON_FONT} />
    },
    {
      title: 'HMI updates',
      path: `/${unit}/admin/hmi-update`,
      renderIcon: () => <CloudSyncIcon fontSize={MENU_ICON_FONT} />
    }
    // {
    //   title: 'Filter Config',
    //   path: '/admin/filter-config',
    //   renderIcon: () => <FilterIcon fontSize={MENU_ICON_FONT} />
    // },
    // {
    //   title: 'Tool life',
    //   path: '/admin/tool-life',
    //   renderIcon: () => <BuildIcon fontSize={MENU_ICON_FONT} />
    // }
  ]

  React.useEffect(() => {
    setFetchingMachineState('fetching')
    fetch(`${process.env.REACT_APP_ADMIN_BASE_URL}/v1/machines`)
      .then((response) => response.json())
      .then((data) => {
        const machineOptions = data.data.map((item) => ({
          value: item.name,
          label: item.displayName
        }))
        setMachinesList(machineOptions)
      })
      .catch((error) => {
        console.error('Error fetching machines:', error)
        setFetchingMachineState('failed')
      })
      .finally(() => {
        setFetchingMachineState('finished')
      })
  }, [])

  const loadingState = ['idle', 'fetching'].includes(fetchingMachineState)

  if (loadingState) {
    return <LoadingSpinner loading={loadingState} text="Loading data..." />
  }

  return (
    <AdminGlobalStateContext.Provider value={{ machines: machinesList }}>
      <App>
        <SidePanel>
          <SidePanelInner>
            <NavBox>
              {SidebarData.map((item, index) => (
                <MenuItem key={index} item={item} />
              ))}
            </NavBox>

            <LogoBox>
              <Link to={`/${unit}`}>
                <LogoWrapper src={Logo} alt="company logo" />
              </Link>
            </LogoBox>
          </SidePanelInner>
        </SidePanel>

        <MainContent>
          <Outlet />
        </MainContent>
      </App>
    </AdminGlobalStateContext.Provider>
  )
}

export default AdminLayout
